(function () {
  $('.sellers_slider').owlCarousel('destroy'); // Destroy previous instance if any
  $(".sellers_slider").owlCarousel({
    nav: true, // Enable navigation arrows
    navText: [
      '<img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">',
      '<img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085">'
    ],
    loop: false,
    margin: 10,
    dots: false,
    responsiveClass: true,
    responsive: {
      0: { items: 1 },
      475: { items: 1 },
      769: { items: 2 },
      1025: { items: 3 },
      1126: { items: 4 },
      1500: { items: 5 }
    }
  });
})();


$('.best_sellers_slider').slick({
	slidesToShow: 5,
   	slidesToScroll: 1,
   	autoplay: true,
   	infinite: true,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
  	responsive: [
    {
      	breakpoint: 1025,
      	settings: {
        	slidesToShow: 3,
        	slidesToScroll: 3,
      }
    },
    {
      	breakpoint: 769,
      	settings: {
        	slidesToShow: 2,
        	slidesToScroll: 2,
      }
    },
    {
      	breakpoint: 475,
      	settings: {
        	slidesToShow: 1,
        	slidesToScroll: 1,
      }
    }
  	]
});


$('.related_products_slider').slick({
	slidesToShow: 4,
   	slidesToScroll: 1,
   	autoplay: true,
   	infinite: true,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
    responsive: [
    {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
      }
    },
    {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      }
    },
    {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
      }
    }
    ]
});


$('.product_detail_slider').slick({
	slidesToShow: 1,
   	slidesToScroll: 1,
   	autoplay: false,
   	infinite: true,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
    responsive: [
      {
          breakpoint: 510,
          settings: {
            arrows: false,
        }
      },
    ]
});


$('.products_may_like_slider').slick({
	slidesToShow: 5,
   	slidesToScroll: 1,
   	autoplay: true,
   	infinite: true,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
    responsive: [
    {
        breakpoint: 1025,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
      }
    },
    {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      }
    },
    {
        breakpoint: 475,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
      }
    }
    ]
});


$('.blog_category_slider').slick({
	slidesToShow: 7,
   	slidesToScroll: 2,
   	autoplay: false,
   	infinite: false,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
  	responsive: [
    {
      	breakpoint: 1260,
      	settings: {
        	slidesToShow: 5,
        	slidesToScroll: 2,
      }
    },
    {
      	breakpoint: 990,
      	settings: {
        	slidesToShow: 3,
        	slidesToScroll: 2,
      }
    },
    {
      	breakpoint: 769,
      	settings: {
        	slidesToShow: 2,
        	slidesToScroll: 1,
      }
    },
    {
      	breakpoint: 427,
      	settings: {
        	slidesToShow: 1,
        	slidesToScroll: 1,
            arrows: false,
      }
    }
  	]
});

const $slider = $('.blog_category_slider');

$slider.on('afterChange', function(event, slick, currentSlide){
    const totalSlides = slick.slideCount;

    if (currentSlide === totalSlides - slick.options.slidesToShow) {
      $('.slick-next').hide(); 
    } else {
      $('.slick-next').show(); 
    }
  });

  if ($slider.slick('slickCurrentSlide') === $slider.slick('getSlick').slideCount - 1) {
    $('.slick-next').hide();
  };


function checkScreenSize() {
  if (window.innerWidth <= 967) {
    $('.blog_category_slider').addClass('blog_category_slider2');
    $('.blog_category_slider').removeClass('blog_category_slider');
  }
  else{
    $('.blog_category_slider2').addClass('blog_category_slider');
    $('.blog_category_slider').removeClass('blog_category_slider2');
  }
}

checkScreenSize();

window.addEventListener('resize', checkScreenSize);


$('.blog_category_slider2').slick({
	slidesToShow: 7,
   	slidesToScroll: 2,
   	autoplay: false,
   	infinite: false,
   	dots: false,
   	arrows: true,
   	prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
  	nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
  	responsive: [
    {
      	breakpoint: 1260,
      	settings: {
        	slidesToShow: 5,
        	slidesToScroll: 2,
      }
    },
    {
      	breakpoint: 990,
      	settings: {
        	slidesToShow: 3,
        	slidesToScroll: 2,
      }
    },
    {
      	breakpoint: 769,
      	settings: {
        	slidesToShow: 2,
        	slidesToScroll: 1,
      }
    },
    {
      	breakpoint: 427,
      	settings: {
        	slidesToShow: 1,
        	slidesToScroll: 1,
            arrows: false,
      }
    }
  	]
});


const $slider2 = $('.blog_category_slider2');

$slider2.on('afterChange', function(event, slick, currentSlide){
    const totalSlides = slick.slideCount;

    if (currentSlide === totalSlides - slick.options.slidesToShow) {
      $('.slick-next').hide(); 
    } else {
      $('.slick-next').show(); 
    }
  });

  if ($slider2.slick('slickCurrentSlide') === $slider2.slick('getSlick').slideCount - 1) {
    $('.slick-next').hide();
  };


$('.reviews_slider').slick({
  slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: false,
    arrows: false,
});


$('.brand_box_slider').slick({
  slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: false,
    arrows: false,
});


$('.secondry_bar_slider').slick({
  slidesToShow: 11,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
    responsive: [
    {
        breakpoint: 1027,
        settings: {
          slidesToShow: 7,
          slidesToScroll: 1,
      }
    },
    {
        breakpoint: 769,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
      }
    },
    {
        breakpoint: 567,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
      }
    },
    {
        breakpoint: 428,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
      }
    }
    ]
});


  $("#secondry_bar_slider").owlCarousel({
  	nav: true,
    navText: ['<img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">', '<img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085">'],
    loop: false,
    margin: 10,
    dots: false,
    responsiveClass: true,
    responsive:{
      0:{
        items: 2,
      },
      428:{
        items: 3,
      },
      567:{
        items: 3,
      },
      769:{
        items: 5,
      },
      1027:{
        items: 7,
      },
      1500:{
        items: 11,
      }
    }
  });



$('.sidebar_products_may_like_slider').slick({
  slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: false,
    arrows: true,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>',
});


$('.text_page_slider').slick({
  slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    dots: false,
    arrows: false,
    prevArrow: '<button type="button" class="slick-custom-arrow slick-prev"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowLeft.svg?v=1725277851">< </button>',
    nextArrow: '<button type="button" class="slick-custom-arrow slick-next"><img src="https://cdn.shopify.com/s/files/1/1442/8846/files/ArrowRight_1.svg?v=1725282085"></button>'
});